import { useState, useRef } from "react";
import api from "../../api/apiClient";

export const AvatarStep = ({ data, onUpdate, onStartGeneration, onBack, onAvatarConfirmed }) => {

  const [playingSummary, setPlayingSummary] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const audioRef = useRef(null);

  const handleSelect = (avatarSrc) => {
    console.log("[AvatarStep] handleSelect-avatar:", avatarSrc);
    onUpdate("avatar", avatarSrc);
  };

  const generateStaticSummary = (formData) => {
    const {
      childName,
      childAge,
      gender,
      theme,
      interests,
      friends,
      siblings,
      parents,
      grandparents,
      favoritePlace,
      favoriteAnimal,
      city,
      avatar,
      duration,
      narrator,
      format,
    } = formData;

    const name = childName || "Robin";
    const pronoun = gender === "boy" ? "han" : "hon";
    const genderText = gender === "boy" ? "pojke" : "flicka";
    const narratorText = narrator.includes("B") ? "WaveNet B"
                        : narrator.includes("C") ? "WaveNet C"
                        : narrator.includes("D") ? "WaveNet D"
                        : "WaveNet A";

    let summary = `Du har valt att skapa en ${format === "audiobook" ? "ljudbok" : "bok"} där hjälten är ${name}`;
    summary += childAge ? `, en ${childAge} år gammal ${genderText}` : `, en ${genderText}`;
    summary += ".";

    if (theme) summary += ` Äventyret utspelar sig med temat "${theme.toLowerCase()}".`;
    if (interests) summary += ` ${name} tycker om att ${interests.toLowerCase()}.`;
    if (friends) summary += ` Några av ${pronoun}s vänner är ${friends}.`;
    if (siblings) summary += ` ${pronoun.charAt(0).toUpperCase() + pronoun.slice(1)} har syskon som heter ${siblings}.`;
    if (parents) summary += ` Föräldrarna heter ${parents}.`;
    if (grandparents) summary += ` Mor- och farföräldrarna är ${grandparents}.`;
    if (favoritePlace) summary += ` En plats ${pronoun} gillar extra mycket är ${favoritePlace}.`;
    if (favoriteAnimal) summary += ` Favoritdjuret är en ${favoriteAnimal}.`;
    if (city) summary += ` ${name} bor i ${city}.`;
    if (avatar) summary += ` Avataren som används i berättelsen är ${avatar}.`;
    if (format === "audiobook" && duration) summary += ` Ljudboken är ungefär ${duration} minuter lång.`;
    if (format === "audiobook" && narrator) summary += ` Den läses upp av ${narratorText} berättarröst.`;

    return summary.trim();
  };

  const handleCreateClick = async () => {
  if (!data.avatar || playingSummary) return;

  setPlayingSummary(true);

  if (onAvatarConfirmed) {
    await onAvatarConfirmed(); // 🔥 Kör hela overlay + tts + mini-story-flödet
  }

  setPlayingSummary(false);
};


  const avatars = data.gender === "boy"
    ? [
        { src: "/images/male1.webp", name: "Äventyraren" },
        { src: "/images/male2.webp", name: "Utforskaren" },
        { src: "/images/male3.webp", name: "Hjälten" },
        { src: "/images/male4.webp", name: "Filosofen" },
        { src: "/images/male5.webp", name: "Upptäckaren" },
        { src: "/images/male6.webp", name: "Tänkaren" },
        { src: "/images/male7.webp", name: "Kämpen" },
        { src: "/images/male8.webp", name: "Drömmaren" },
      ]
    : [
        { src: "/images/female1.webp", name: "Prinsessan" },
        { src: "/images/female2.webp", name: "Äventyraren" },
        { src: "/images/female3.webp", name: "Hjälten" },
        { src: "/images/female4.webp", name: "Upptäckaren" },
        { src: "/images/female5.webp", name: "Filosofen" },
        { src: "/images/female6.webp", name: "Utforskaren" },
        { src: "/images/female7.webp", name: "Kämpen" },
        { src: "/images/female8.webp", name: "Drömmaren" },
      ];

  return (
  <div className="space-y-6 animate-fadeIn">
    <h2 className="text-2xl font-semibold text-center mb-8">
      Välj en avatar för {data.childName}
    </h2>

    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {avatars.map((avatar, index) => (
        <div
          key={index}
          className={`relative aspect-square ${
            data.avatar === avatar.src
              ? "border-4 border-blue-500"
              : "border-2 border-gray-300"
          } rounded-lg cursor-pointer transition-transform transform hover:scale-105`}
          onClick={() => handleSelect(avatar.src)}
        >
          <img
            src={avatar.src}
            alt={avatar.name}
            className="w-full h-full object-cover rounded-lg"
          />
          <p className="absolute bottom-2 left-1/2 transform -translate-x-1/2 
                        text-white bg-black bg-opacity-50 rounded px-2">
            {avatar.name}
          </p>
        </div>
      ))}
    </div>

    <button
      type="button"
      onClick={handleCreateClick}
      disabled={!data.avatar || playingSummary}
      className={`w-full text-white py-2 rounded-lg hover:opacity-90 transition ${
        data.avatar && !playingSummary ? "" : "opacity-50 cursor-not-allowed"
      }`}
      style={
        data.avatar
          ? { background: "linear-gradient(90deg, rgb(51, 101, 126), #347fa4, rgb(51, 101, 126))" }
          : { backgroundColor: "#ccc" }
      }
    >
      {playingSummary ? "Spelar upp sammanfattning..." : "Skapa bok"}
    </button>

    {playingSummary && (
      <p className="text-center text-xl text-gray-600 mt-2">
        Vi skapar din bok nu. Du får ett mail när den är klar! ✨
      </p>
    )}
  </div>
);

};
